import { LinearProgress } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@mui/material/Grid";
import { Component } from "react";
import styles from "../../../../../../../styles/CustomMuiStyles";
const isBrowser = () => typeof window !== "undefined";

class PricesDisplaySqueleton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: isBrowser() && window.matchMedia("(min-width: 990px)").matches,
    };
  }
  render() {
    const { classes } = this.props;
    return (
      <div className="CDP-container">
        <Grid container spacing={0}>
          <Grid item xs={12} style={{ backgroundColor: "white" }}>
            <Grid container spacing={0}>
              <Grid
                item
                xs={12}
              // classes={
              //   this.state.matches
              //     ? {
              //         root: classes.CDPFullElementGrid,
              //       }
              //     : {
              //         root: classes.CDPFullElementGridMobile,
              //       }
              // }
              >
                <Grid container spacing={0}>
                  <Grid
                    item
                    xs={6}
                  // classes={{
                  //   root: classes.CDPMainElementGrid,
                  // }}
                  >
                    <div className="cdp-main-element">
                      <span>{this.props.type}</span>
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={3}
                  // classes={{
                  //   root: classes.CDPElementGrid,
                  // }}
                  >
                    {this.state.matches ? (
                      <span>{this.props.t("Prix m² moyen Appartement")}</span>
                    ) : (
                      <span>{this.props.t("Prix m² moyen Appt.")}</span>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={3}
                  // classes={{
                  //   root: classes.CDPElementGrid,
                  // }}
                  >
                    {this.props.t("Prix m² moyen Villa")}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((element, index) => {
            return (
              <Grid
                key={index}
                item
                xs={12}
                // style={index % 2 ? { backgroundColor: "white" } : null}
                style={{ backgroundColor: "white" }}
              >
                <Grid container spacing={0}>
                  <Grid
                    item
                    xs={6}
                    classes={{
                      root: classes.CDPSqueletonGrid,
                    }}
                  >
                    <LinearProgress
                      classes={{
                        colorPrimary: classes.colorPrimary,
                        barColorPrimary: classes.barColorPrimary,
                        root: classes.squeletonRoot,
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    classes={{
                      root: classes.CDPSqueletonGrid,
                    }}
                  >
                    <LinearProgress
                      classes={{
                        colorPrimary: classes.colorPrimary,
                        barColorPrimary: classes.barColorPrimary,
                        root: classes.squeletonRoot,
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    classes={{
                      root: classes.CDPSqueletonGrid,
                    }}
                  >
                    <LinearProgress
                      classes={{
                        colorPrimary: classes.colorPrimary,
                        barColorPrimary: classes.barColorPrimary,
                        root: classes.squeletonRoot,
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            );
          })}{" "}
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(PricesDisplaySqueleton);
